import {Mapper} from '@s-ui/domain'

export class FromVehicleConfiguratorDealerRawDataToDealerEntityMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Function} param.dealerEntityFactory
   * @param {FromDealerLocationJsonToLocationValueObjectMapper} param.fromDealerLocationJsonToLocationValueObjectMapper
   */
  constructor({config, dealerEntityFactory, fromDealerLocationJsonToLocationValueObjectMapper}) {
    super()

    this._config = config
    this._dealerEntityFactory = dealerEntityFactory
    this._fromDealerLocationJsonToLocationValueObjectMapper = fromDealerLocationJsonToLocationValueObjectMapper
  }

  _mapDealerStore = store => {
    const {
      dealerIdentity: {id},
      dealerName: name,
      location,
      totalResults: totalPublishedVehicles
    } = store

    const locationVO = this._fromDealerLocationJsonToLocationValueObjectMapper.map(location)

    return this._dealerEntityFactory({
      id,
      location: locationVO,
      name,
      totalPublishedVehicles
    })
  }

  /**
   * @param {Object} rawData
   * @returns {DealerEntity}
   */
  map = rawData => {
    const {
      contact: {phone: phoneNumber, hasCallTrackingService, hidePhone = false} = {},
      externalContractId, // companyWasId
      externalPageUrl,
      hasFinancingProduct,
      hasReservation,
      id,
      location,
      logoUrl: logoImageUrl,
      moreInformation,
      name,
      pack: {type: pack} = {},
      relatedStores: stores = [],
      schedule,
      isActive,
      storeImageUrls,
      videos
    } = rawData

    const locationVO = this._fromDealerLocationJsonToLocationValueObjectMapper.map(location)

    const relatedStores = stores.map(this._mapDealerStore)

    return this._dealerEntityFactory({
      externalContractId,
      externalPageUrl,
      hasCallTrackingService,
      hasFinancingProduct,
      hasReservation,
      hidePhone,
      id,
      location: locationVO,
      logoImageUrl,
      moreInformation,
      name,
      pack,
      phoneNumber,
      relatedStores,
      schedule,
      storeImageUrls,
      videos,
      isActive
    })
  }
}
